import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import Swal from "sweetalert2";
import { BaseInput, BaseSelect, BaseButton, BaseTextarea } from "../../components/ui";
import inmuebleService from "../../services/inmuebleService";
import gastoService from "../../services/gastoService";

const CATEGORIAS = [
  { value: 'MANTENIMIENTO', label: 'Mantenimiento' },
  { value: 'SERVICIOS', label: 'Servicios Públicos' },
  { value: 'REPARACIONES', label: 'Reparaciones' },
  { value: 'LIMPIEZA', label: 'Limpieza' },
  { value: 'SEGURIDAD', label: 'Seguridad' },
  { value: 'ADMINISTRATIVO', label: 'Gastos Administrativos' },
  { value: 'OTROS', label: 'Otros' },
];

const GastosRegistrar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [inmuebles, setInmuebles] = useState([]);
  const [formData, setFormData] = useState({
    inmueble_id: '',
    categoria: '',
    concepto: '',
    monto: '',
    fecha_gasto: '',
    observaciones: '',
  });

  useEffect(() => {
    const fetchInmuebles = async () => {
      try {
        const data = await inmuebleService.obtenerInmuebles();
        setInmuebles(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error al obtener inmuebles:", error);
      }
    };

    fetchInmuebles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      await gastoService.crearGasto({
        ...formData,
        monto: parseFloat(formData.monto),
        estado: 'PENDIENTE',
      });

      Swal.fire({
        title: "¡Éxito!",
        text: "Gasto registrado correctamente",
        icon: "success",
      }).then(() => navigate("/contabilidad-gastos"));
    } catch (error) {
      console.error("Error al registrar gasto:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudo registrar el gasto",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar id="menu-item6" id1="menu-items6" activeClassName="gastos-registrar" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/contabilidad-gastos">Contabilidad</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FiChevronRight />
                  </li>
                  <li className="breadcrumb-item active">Registrar gasto</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Registrar gasto</h4>
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseSelect
                          label="Inmueble"
                          name="inmueble_id"
                          required
                          isSearchable
                          value={formData.inmueble_id}
                          onChange={handleChange}
                          placeholder="Seleccionar inmueble"
                          options={inmuebles.map((i) => ({ value: i.id, label: i.nombre }))}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseSelect
                          label="Categoría"
                          name="categoria"
                          required
                          value={formData.categoria}
                          onChange={handleChange}
                          placeholder="Seleccionar categoría"
                          options={CATEGORIAS}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseInput
                          label="Monto"
                          name="monto"
                          type="number"
                          required
                          restrict="decimal"
                          min="0"
                          step="0.01"
                          value={formData.monto}
                          onChange={handleChange}
                          placeholder="0.00"
                          startIcon={<span>S/</span>}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <BaseInput
                          label="Fecha del gasto"
                          name="fecha_gasto"
                          type="date"
                          required
                          value={formData.fecha_gasto}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12">
                        <BaseInput
                          label="Concepto"
                          name="concepto"
                          required
                          value={formData.concepto}
                          onChange={handleChange}
                          placeholder="Descripción breve del gasto"
                        />
                      </div>

                      <div className="col-12">
                        <BaseTextarea
                          label="Observaciones"
                          name="observaciones"
                          rows={3}
                          value={formData.observaciones}
                          onChange={handleChange}
                          placeholder="Notas adicionales (opcional)"
                        />
                      </div>

                      <div className="col-12 d-flex justify-content-end gap-2 mt-2">
                        <BaseButton
                          type="button"
                          variant="secondary"
                          onClick={() => navigate("/contabilidad-gastos")}
                        >
                          Cancelar
                        </BaseButton>
                        <BaseButton type="submit" variant="primary" loading={loading} disabled={loading}>
                          Registrar gasto
                        </BaseButton>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GastosRegistrar;
